import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const team = [
  {
    name: 'Master Tailor',
    role: 'Head Clothier & Founder',
    img: 'https://public.readdy.ai/ai/img_res/7ca7d0bbae6626550da4690104bbeac5.jpg',
    bio: 'With over 55 years of bespoke tailoring experience, our head clothier brings old-world craftsmanship to every garment.',
  },
  {
    name: 'Senior Tailor',
    role: 'Custom Shirts & Alterations',
    img: 'https://readdy.ai/api/search-image?query=professional%20senior%20tailor%20portrait%20elegant%20studio%20warm%20lighting%20experienced%20craftsman%20menswear%20alterations%20expert%20wellesley&width=400&height=400&seq=team2&orientation=squarish',
    bio: 'Specializing in custom shirts and precision alterations, bringing meticulous attention to detail to every stitch.',
  },
  {
    name: 'Style Consultant',
    role: 'Client Experience & Styling',
    img: 'https://readdy.ai/api/search-image?query=professional%20style%20consultant%20portrait%20elegant%20studio%20warm%20lighting%20fashion%20expert%20menswear%20wellesley%20massachusetts%20friendly%20professional&width=400&height=400&seq=team3&orientation=squarish',
    bio: 'Our style consultant guides clients through fabric selection, design choices, and wardrobe planning with a personal touch.',
  },
];

const milestones = [
  { year: '1970', event: 'Custom Clothiers founded in Wellesley, MA' },
  { year: '1985', event: 'Expanded to full bespoke suit and shirt services' },
  { year: '2000', event: 'Launched house and office call program across Massachusetts' },
  { year: '2010', event: 'Recognized as one of Boston\'s top custom tailors' },
  { year: '2020', event: 'Celebrated 3500+ satisfied clients and counting' },
  { year: '2024', event: 'Continuing to serve Massachusetts and New England with the same passion' },
];

const values = [
  { icon: 'ri-heart-line', title: 'Passion for Craft', desc: 'Every garment is made with genuine love for the art of tailoring.' },
  { icon: 'ri-shield-check-line', title: 'Uncompromising Quality', desc: 'We use only the finest fabrics and construction techniques.' },
  { icon: 'ri-user-heart-line', title: 'Client-First Service', desc: 'Your satisfaction is our only measure of success.' },
  { icon: 'ri-map-pin-line', title: 'Local Roots', desc: 'Proudly serving the Wellesley and Massachusetts community for over 55 years.' },
];

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="relative h-[65vh] min-h-[480px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20custom%20tailor%20shop%20interior%20wellesley%20massachusetts%20elegant%20showroom%20fabric%20rolls%20warm%20lighting%20bespoke%20clothier%20premium%20menswear%20boutique&width=1400&height=700&seq=abouthero&orientation=landscape"
          alt="About Custom Clothiers"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 to-gray-900/40"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-4">Our Story</p>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Crafting Excellence<br />Since 1970
          </h1>
          <p className="text-xl text-gray-200 max-w-xl mb-8">
            For over 55 years, Custom Clothiers has been Wellesley's trusted destination for bespoke tailoring, custom suits, and expert alterations.
          </p>
          <Link to="/contact" className="bg-[#C4A962] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap inline-block">
            Meet Our Team
          </Link>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">A Legacy of Bespoke Tailoring in Wellesley, MA</h2>
              <p className="text-gray-500 text-lg leading-relaxed mb-6">
                Custom Clothiers was founded with a simple belief: every person deserves clothing that fits perfectly and reflects their unique personality. Since opening our doors in Wellesley in 1970, we have built lasting relationships with clients across Massachusetts and New England who trust us with their most important moments.
              </p>
              <p className="text-gray-500 text-lg leading-relaxed mb-6">
                From wedding suits to boardroom blazers, from custom shirts to expert alterations — we bring the same level of care, craftsmanship, and personal attention to every garment we create.
              </p>
              <p className="text-gray-500 text-lg leading-relaxed mb-8">
                Our showroom at 326A Washington Street in Wellesley is a welcoming space where clients can explore 5000+ fabrics available for suits, work one-on-one with our master tailors, and experience the difference of truly bespoke clothing.
              </p>
              <div className="flex flex-wrap gap-8">
                {[
                  { num: '55+', label: 'Years in Business' },
                  { num: '3500+', label: 'Happy Clients' },
                  { num: '5000+', label: 'Premium Fabrics' },
                ].map((stat) => (
                  <div key={stat.label}>
                    <p className="text-4xl font-bold text-[#C4A962]">{stat.num}</p>
                    <p className="text-gray-500 text-sm mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=bespoke%20tailor%20shop%20interior%20fabric%20swatches%20measuring%20tape%20elegant%20showroom%20warm%20lighting%20premium%20menswear%20boutique%20wellesley%20massachusetts&width=600&height=550&seq=aboutstory&orientation=landscape"
                alt="Our Showroom"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">What We Stand For</h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">Our values guide every garment we create and every client relationship we build.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 text-center hover:shadow-md transition-shadow">
                <div className="w-14 h-14 flex items-center justify-center bg-[#C4A962]/10 rounded-2xl mx-auto mb-5">
                  <i className={`${v.icon} text-[#C4A962] text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{v.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Meet Our Team</h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">Experienced craftspeople dedicated to making you look and feel your best.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {team.map((member) => (
              <div key={member.name} className="text-center">
                <div className="w-40 h-40 rounded-full overflow-hidden mx-auto mb-6 shadow-lg">
                  <img src={member.img} alt={member.name} className="w-full h-full object-cover object-top" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">{member.name}</h3>
                <p className="text-[#C4A962] font-medium text-sm mt-1 mb-3">{member.role}</p>
                <p className="text-gray-500 text-sm leading-relaxed">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold mb-4">Our Journey</h2>
            <p className="text-gray-400 text-lg">Over 55 years of craftsmanship, growth, and community.</p>
          </div>
          <div className="space-y-8">
            {milestones.map((m, i) => (
              <div key={m.year} className="flex items-start gap-6">
                <div className="flex-shrink-0 w-20 text-right">
                  <span className="text-[#C4A962] font-bold text-lg">{m.year}</span>
                </div>
                <div className="flex-shrink-0 flex flex-col items-center">
                  <div className="w-4 h-4 rounded-full bg-[#C4A962] mt-1"></div>
                  {i < milestones.length - 1 && <div className="w-0.5 h-12 bg-[#C4A962]/30 mt-1"></div>}
                </div>
                <div className="pb-4">
                  <p className="text-gray-200 leading-relaxed">{m.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#C4A962]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">Come Visit Us in Wellesley</h2>
          <p className="text-white/80 text-lg mb-8">We would love to meet you and start your custom tailoring journey. Consultations are always complimentary.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="bg-white text-[#C4A962] px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap">
              Book a Consultation
            </Link>
            <a href="tel:781-237-3166" className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white/10 transition-colors whitespace-nowrap">
              Call 781-237-3166
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
